@if (categoryTitle) {
  @if (contentfulCategory?.titleLevel === 1) {
    <h1 class="heading-text">
      <span class="category-heading" [innerHTML]="categoryTitle | sanitizeContentfulHTML"> </span>
    </h1>
  } @else if (contentfulCategory?.titleLevel !== 1) {
    <h2 class="heading-text">
      <span class="category-heading" [innerHTML]="categoryTitle | sanitizeContentfulHTML"> </span>
    </h2>
  }
}
